/**
 * Returns a string containing the guardian's first and last names separated
 * by a single space.
 *
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import useUser from './useUser';

const useGuardianName = (userID) => {
  const user = useUser(userID);
  return user ? `${user.firstName} ${user.lastName}` : '';
};

export default useGuardianName;
